<template>
    <div class="white-bg relative">
<!--        <div class="enterprise-rank-title">企业排行榜</div>-->
        <ul class="RankingList">
            <li class="enterprise-item flex align-items" v-for="(item,index) in epMoneyRank" :key="item.id">
                <p class="position icon">
                    <img src="@/assets/images/one-icon.png" v-if="index===0">
                    <img src="@/assets/images/two-icon.png" v-if="index===1">
                    <img src="@/assets/images/three-icon.png" v-if="index===2">
                    <i v-if="index===3">4</i>
                    <i v-if="index===4">5</i>
                    <i v-if="index===5">6</i>
                    <i v-if="index===6">7</i>
                    <i v-if="index===7">8</i>
                    <i v-if="index===8">9</i>
                    <i v-if="index===9">10</i>
                </p>
                <p class="enterprise-logo"><img :src="item.enterprise_logo" class="img"></p>
                <p class="enterprise-text">
                    <span class="name ellipsis">{{item.name}}</span>
                    <span class="number">
                        <i class="ff9203">￥{{item.money}}</i>
                        推广量：{{item.clickNum}}+
                    </span>
                </p>
            </li>
        </ul>
    </div>
</template>
<script>
import {homeData} from '@/config/api.js'
export default {
  name: 'EnterpriseRanking',
  data () {
    return {
        epMoneyRank: [{
            name: '',
            enterprise_logo: '',
            money: '',
            clickNum: ''
        }]
    }
  },
    methods: {
        getCount () {
            let data = {
            };
            this.$post(homeData,data)
                .then(res => {
                    this.epMoneyRank = res.data.epMoneyRank;
                })
                .catch(err => {
                    window.console.log("err", err);
                });
        }
    },
    mounted () {
        this.getCount()
    }
}
</script>
<style scoped>
    .enterprise-rank-title{line-height:46px;font-size:14px;border-bottom:1px #eee solid;padding:0 15px;}
    .enterprise-item{border-bottom:1px #eee solid;padding:15px;}
    .enterprise-item .enterprise-logo{margin:0 10px;}
    .enterprise-item .enterprise-logo .img{width:40px;height:40px;border-radius:50%;}
    .enterprise-item .enterprise-text{line-height:20px;}
    .enterprise-item .enterprise-text .name{width:185px;display: block;}
    .enterprise-item .position{width:24px;}
    .enterprise-item .icon i{display:block;width:24px;height:24px;line-height:24px;border-radius:100%;background:#eee;text-align: center;}
</style>
